import './styles.scss';
import * as $ from 'jquery';

import axios from 'axios';

export default function initSearchAutocomplete() {
  const HIDE_SUGGESTIONS_DELAY = 250;

  /**
   * Returns a Funnelback JSON endpoint URL, given a Funnelback collection ID and
   * a search query term.
   * @param {string} query Search query term
   * @param {string} collection Funnelback collection ID
   */
  const getAutoComplete = (
    query,
    collection = 'djsir~sp-defence-victoria',
    profile = '_default'
  ) => {
    const autoCompleteUrl = `https://djsir-search.funnelback.squiz.cloud/s/suggest.json?collection=${collection}&profile=${profile}&show=10&sort=0&alpha=.5&fmt=json++&partial_query=${query}`;
    return axios(autoCompleteUrl).then((response) => response.data);
  };

  /**
   * Takes a search suggestion and wraps all instances of the partial search
   * query found within it with a span to target styling.
   * @param {string} suggestion The returned search suggestion
   * @param {string} query The partial search query
   */
  const highlightQuery = (suggestion, query) => {
    return suggestion.replace(new RegExp([query], 'gi'), function (result) {
      return `<span class="font-weight-medium">${result}</span>`;
    });
  };

  /**
   * Given a search form's child element, this function searches up the DOM tree
   * to find the parent form element, and then set focus to the search input
   * field element.
   * @param {Element} childElement Child element of a search form
   */
  const focusSearchInput = (childElement) => {
    $(childElement)
      .closest('form')
      .find('.form-control[name="query"]')
      .trigger('focus');
  };

  // =============================================================================
  // EVENT HANDLERS
  // =============================================================================

  /**
   * Get auto-complete search suggestions on keyup and focus events for each
   * search input element on the page.
   */
  $(document).on(
    'keyup focus',
    '.form-control[name="query"]',
    function (event) {
      const $form = $(this).closest('form');
      const $suggestionsContainer = $form.find('.search-suggestions');

      clearTimeout(window.hideSearchSuggestionsTimer);

      if (event.key === 'ArrowDown') {
        $suggestionsContainer
          .find('a.list-group-item:first-child')
          .trigger('focus');
      } else {
        const query = $(this)[0].value;
        const resultsPageUrl = $form.attr('action');
        const collection = $form.children(
          'input[type="hidden"][name="collection"]'
        )[0].value;
        const profile = $form.children(
          'input[type="hidden"][name="profile"]'
        )[0]?.value;

        getAutoComplete(query, collection, profile).then((suggestions) => {
          if (suggestions.length > 0) {
            let suggestionElems = '';
            suggestions.forEach(({ disp: suggestion }) => {
              const searchUrl = `${resultsPageUrl}?collection=${collection}&profile=${profile}&query=${suggestion}`;
              suggestionElems += `
            <a
              class="list-group-item list-group-item-action"
              href="${searchUrl}">
              ${highlightQuery(suggestion, query)}
            </a>`;
            });
            $suggestionsContainer.html(suggestionElems).show();
          } else {
            $suggestionsContainer.html('').hide();
          }
        });
      }
    }
  );

  /**
   * Use ArrowDown and ArrowUp to navigate the search suggestions list, Enter to
   * select an item, and any other key to return focus to the search input field.
   */
  $(document).on(
    'keydown',
    'form a.list-group-item.list-group-item-action',
    function (event) {
      if (
        ['Enter', 'Tab', 'Shift', 'Alt', 'Control', 'Meta'].includes(event.key)
      ) {
        return;
      }

      event.preventDefault();

      if (event.key === 'ArrowDown') {
        if ($(this).is(':last-child')) {
          $(this).parent().children(':first-child').trigger('focus');
        } else {
          $(this).next().trigger('focus');
        }
        return false;
      }

      if (event.key === 'ArrowUp') {
        if ($(this).is(':first-child')) {
          focusSearchInput(this);
        } else {
          $(this).prev().trigger('focus');
        }
        return false;
      }

      focusSearchInput(this);
      return false;
    }
  );

  /**
   * Hide the search suggestions when focus is shifted away from a search
   * suggestion list item.
   */
  $(document).on('blur', '.search-suggestions', function (event) {
    // If focus is shifted to a search suggestion list item, then do nothing...
    if (
      event.relatedTarget &&
      event.relatedTarget.parentNode.classList.contains('search-suggestions')
    ) {
      return;
    }

    // Otherwise, clear and hide the search suggestions list.
    window.hideSearchSuggestionsTimer = setTimeout(() => {
      $(this).html('').hide();
    }, HIDE_SUGGESTIONS_DELAY);
  });

  /**
   * Hide the search suggesions list when focus is shifted away from the search
   * input field to anything other than the search button or a search suggestion
   * list item.
   */
  $(document).on('blur', '.form-control[name="query"]', function (event) {
    // If focus is shifted to the seach button, then do nothing...
    if (
      event.relatedTarget &&
      event.relatedTarget.classList.contains('btn') &&
      event.relatedTarget.parentNode.classList.contains('input-group')
    ) {
      return;
    }

    // If focus is shifted to a search suggestion list item, then do nothing...
    if (
      event.relatedTarget &&
      event.relatedTarget.parentNode.classList.contains('search-suggestions')
    ) {
      return;
    }

    // Otherwise, clear and hide the search suggestions list.
    window.hideSearchSuggestionsTimer = setTimeout(() => {
      $(this).siblings('.search-suggestions').html('').hide();
    }, HIDE_SUGGESTIONS_DELAY);
  });
}
